
import { defineComponent } from 'vue';
import { AxiosError } from "axios";

interface State {
  errors: AxiosError[]
}

export default defineComponent({
  name: 'Logout',
  mounted() {
    this.$nextTick(() => {
      this.callLogout()
    })
  },
  data: (): State => {
    return {
      errors: []
    }
  },
  methods: {
    callLogout() {
      this.errors = [];
      this.$store.dispatch("logout")
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        })
    }
  }
});
